<script setup lang="ts">
  import { Dialog, Text, Button, IconBasketLarge } from '@ui-kit';
  import { useItemUnsetZone, ResponseCode } from '@src/api';

  const { productId, zoneId } = defineProps<{ productId?: string; zoneId?: string; }>();
  const emit = defineEmits<{ 'click:close': [value: void]; 'click:delete': [value: void] }>();

  const { mutateAsync: itemUnsetZone } = useItemUnsetZone();

  const handleDelete = async () => {
    const result = await itemUnsetZone({ item_id: productId, zone_id: zoneId });

    if (result.code === ResponseCode.OK) {
      emit('click:delete');
      emit('click:close');
    }
  };
</script>

<template>
  <Dialog @close="emit('click:close')" :isOpen="!!productId">
    <div class="delete-modal" data-testid="delete-item-modal">
      <div class="delete-modal__content">
        <IconBasketLarge />
        <div class="delete-modal__content-description">
          <Text font="body-bold-18">{{ $t('Удалить товар') + '?' }}</Text>
          <Text font="body-regular-14">{{ $t('Это действие нельзя отменить') }}</Text>
        </div>
      </div>
      <div class="delete-modal__footer">
        <Button variant="negative" size="s" @click="handleDelete" data-testid="delete-item-modal-btn">{{ $t('Удалить') }}</Button>
        <Button variant="secondary" size="s" @click="emit('click:close')" data-testid="cancel-item-modal-btn">{{ $t('Отменить') }}</Button>
      </div>
    </div>
  </Dialog>
</template>

<style scoped>
  .delete-modal {
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 300px;
    padding: 24px 20px 20px;
  }
  
  .delete-modal__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
  }

  .delete-modal__content-description {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
  }

  .delete-modal__footer {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .delete-modal__footer button {
    width: 100%;
  }
</style>